/**
 * Desktop price-input sanitizer: strips every Unicode letter (Latin,
 * Cyrillic, Uzbek) while keeping digits, spaces, and symbols — the ban
 * covers letters only by design (BP-7737), so "500$" stays intact.
 *
 * The regex is built per call on purpose:
 * - `\p{L}` needs ES2018 Unicode property escapes; constructing lazily keeps
 *   a legacy runtime from crashing the whole chunk at module evaluation —
 *   only this input would break, only when typed into.
 * - a fresh instance avoids the shared `g`-flag `lastIndex` footgun.
 * The constructor form (not a literal) is required because tsc rejects
 * `u`-flag literals under the es5 target (TS1501).
 */
export const sanitizePriceInput = (value: string): string =>
  // eslint-disable-next-line prefer-regex-literals
  value.replace(new RegExp('\\p{L}', 'gu'), '');
